import { render } from "./Admin.vue?vue&type=template&id=63128466&scoped=true&ts=true"
import script from "./Admin.vue?vue&type=script&lang=ts"
export * from "./Admin.vue?vue&type=script&lang=ts"

import "./Admin.vue?vue&type=style&index=0&id=63128466&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63128466"]])

export default __exports__